export const enum HeatmapEvent {
  HeatmapArrowClicked = 'Heatmap arrow clicked',
}

export const HEATMAP_CHART_ID = 'heatmap-chart';
export const BORDER_WIDTH = 4;
export const MINIMUM_WIDTH_OF_TILE = 16;
export const CATEGORIES_LIMIT = 21;
export const HEATMAP_DAYS_LIMIT = 31;
